import Page from "./Page";
import Splash from "../components/home/Splash";
import TaskPrioritization from "../components/home/TaskPrioritization";
import LabelsAndNotes from "../components/home/LabelsAndNotes";
import Deadlines from "../components/home/Deadlines";
import { useRef } from "react";

const HomePage = () => {
  const scrollToRef = useRef();

  return (
    <Page className="home-page" pageKey="home">
      <Splash scrollToRef={scrollToRef} />
      <TaskPrioritization scrollToRef={scrollToRef} />
      <LabelsAndNotes />
      <Deadlines />
    </Page>
  );
};

export default HomePage;
